// extracted by mini-css-extract-plugin
export var blue = "_1o-g";
export var brand = "_1o-c";
export var darkGrey = "_1o-f";
export var disabled = "_1o-6";
export var disabledSubtle = "_1o-7";
export var error = "_1o-8";
export var green = "_1o-h";
export var grey = "_1o-e";
export var icon = "_1o-0";
export var inherit = "_1o-b";
export var lightGrey = "_1o-d";
export var orange = "_1o-j";
export var pink = "_1o-l";
export var primary = "_1o-1";
export var purple = "_1o-m";
export var quaternary = "_1o-4";
export var quinary = "_1o-5";
export var red = "_1o-k";
export var secondary = "_1o-2";
export var success = "_1o-a";
export var tertiary = "_1o-3";
export var warning = "_1o-9";
export var white = "_1o-n";
export var yellow = "_1o-i";